<template>
  <div id="choose-product" class="tw-w-full tw-px-4 md:tw-px-0 md:tw-w-10/12 tw-mt-12 tw-mb-6 tw-flex tw-flex-wrap tw-justify-start tw-pb-5">
    <v-card
        id="motor-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat
    >
      <v-icon color="primary" size="80" alt="car">mdi-car-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text  title-font tw-text-base md:tw-text-xl tw-px-3 tw-mt-4">Motor Insurance</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Looking to Cover your vehicle?</p>
        <v-btn id="proceed" color="primary" class="my-3" @click="proceedCar">
          Get Quote
        </v-btn>
      </div>
    </v-card>
    <v-card
        id="marine-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat
    >
      <v-icon color="primary" size="80" alt="car">mdi-hospital-box-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text title-font tw-text-base md:tw-text-xl tw-px-3 tw-mt-4">Pacis Amani-Medical</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Cover yourself and your family
          on matters medical</p>
        <!-- <v-btn id="marine" color="primary" class="my-3" @click="proceedAmani()" href="/docs/New_Pacis_Amani_Brochure.pdf" download>
          Get Quote & Brochure
        </v-btn> -->
        <v-btn id="marine" color="primary" class="my-3" @click="proceedAmani()" href="https://bit.ly/3ZMMRwq" target="_blank" download>
          Get Quote & Brochure
        </v-btn>
      </div>
    </v-card>
    <v-card
        id="domestic-package"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat
    >
      <v-icon color="primary" size="80" alt="car">mdi-home-circle-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text title-font tw-text-base md:tw-text-xl tw-px-3 tw-mt-4">Domestic Package</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Cover yourself and your family
          on your hard earned assets</p>
        <v-btn id="domesticPackage" href="" target="_blank" color="primary" class="my-3" @click="proceedDP()">
          Get Quote
        </v-btn>
      </div>
    </v-card>
    <!-- <v-card
        id="personal-accident"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat
    >
      <v-icon color="primary" size="80" alt="car">mdi-bandage</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text title-font tw-text-base md:tw-text-xl tw-px-3 tw-mt-4">Personal Accident</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Cover yourself and your family
          against accidents</p>
        <v-btn id="marine" href="http://212.22.167.19/pacisapp/backend/web/personal-accident-packages/create" target="_blank" color="primary" class="my-3" @click="$analytics.logEvent(marineName)">
          Get Quote
        </v-btn>
      </div>
    </v-card> -->
    <!-- <v-card
        id="travel-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat
    >
      <v-icon color="primary" size="80" alt="car">mdi-shield-airplane-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text title-font tw-text-base md:tw-text-xl tw-px-3 tw-mt-4">Travel Insurance</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Planning to Travel?</p>
        <v-btn id="travel" href="" target="_blank" color="primary" class="my-3" @click="$analytics.logEvent(travelName)">
          Get Quote
        </v-btn>
      </div>
    </v-card> -->
  </div>
</template>

<script>
import {
  FB_CHOOSE_AMANI,
  FB_CHOOSE_MARINE, FB_CHOOSE_RFQ, FB_CHOOSE_TRAVEL, FB_INIT, FB_CHOOSE_DOMESTIC,
} from '@/utils/const';

export default {
  name: 'ChooseProduct',
  mounted() {
    this.$analytics.logEvent(FB_INIT, { product: 'Insurance Products' });
  },
  computed: {
    travelName() {
      return FB_CHOOSE_TRAVEL;
    },
    marineName() {
      return FB_CHOOSE_MARINE;
    },
  },
  methods: {
    proceedCar() {
      this.$analytics.logEvent(FB_CHOOSE_RFQ, { product: 'Motor Private' });
      this.$emit('proceed-request');
    },
    proceedAmani() {
      this.$analytics.logEvent(FB_CHOOSE_AMANI);
      this.$emit('proceed-amani-request');
    },
    proceedDP() {
      this.$analytics.logEvent(FB_CHOOSE_DOMESTIC);
      this.$emit('proceed-dp-request');
    },
  },
};
</script>

<style scoped>
.bg-size {
  background-size: 80px;
}
</style>
